import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import {
  add_member,
  get_membe_by_member_no,
  get_member,
} from "../../services/membership.service";
import { useStore } from "../../store";
import converSex from "../../helpers/convertSex";
import convertNumber from "../../helpers/convertNumber";
import convertNumberReverse from "../../helpers/convertNumberReverse";
import FormControlCustom from "../FormControlCustom";
import LoadingComponent from "../LoadingComponent";
import addBranchNo from "../../helpers/addBranchNo";
import {
  get_activity_history,
  get_activity_history_by_balance_id,
} from "../../services/balance.service";
import cutBranchNo from "../../helpers/cutBranchNo";
export default function PopUpUpdateDepositAndWithdraw({
  open,
  onClose,
  onSubmit,
  activityHistoryId,
  backupFormData,
  setBackupFormData,
  setPopup,
}) {
  // state
  const [isLoading, setIsLoading] = useState(false); // loading
  const [searchLoading, setSearchLoading] = useState(false); // loading
  const [inputSearch, setInputSearch] = useState("");
  const [memberData, setMemberData] = useState();
  const [activityHistory, setActivityHistory] = useState();
  const [formData, setFormData] = useState({ type: "DEPOSIT" });
  const [validate, setValidate] = useState({
    balanceAmount: false,
    description: false,
  });
  const [validateMessage, setValidateMessage] = useState({
    balanceAmount: "",
    description: "",
  });

  // store
  const { token, profile, branchData } = useStore();

  // useEffect
  useEffect(() => {
    // if (profile?.branchId) {
    //   setFormData((prev) => ({ ...prev, branchId: profile?.branchId }));
    // }
    // getMemberData();
    if (activityHistoryId) {
      getActivityHistoryData(activityHistoryId);
    }
  }, [activityHistoryId, profile, open]);
  // useEffect
  useEffect(() => {
    if (profile?.branchId) {
      setFormData((prev) => ({ ...prev, branchId: profile?.branchId }));
    }
    if (backupFormData) {
      setFormData((prev) => ({ ...prev, ...backupFormData?.formData }));
      setMemberData(backupFormData?.memberData);
      setInputSearch(backupFormData?.inputSearch);
    }
  }, [backupFormData, profile]);

  // function
  const checkValidate = () => {
    let _validate = {};
    let _validateMessage = {};
    let state = false;

    /**
     * ກວດຂໍ້ມູນສະມາສິກ
     *
     * !ຂໍ້ມູນສະມາສິກ
     */
    if (!memberData?._id) {
      _validate.memberData = true;
      _validateMessage.memberData = "ຄົ້ນຫາຕາມເລກສະມາຊິກ";
      console.error("memberData._id empty");
      state = true;
    }

    /**
     * ກວດ id ສາຂາ
     *
     * !id ສາຂາ
     */
    if (!formData?.branchId) {
      _validate.branchId = true;
      console.error("formData.branchId empty");
      state = true;
    }

    /**
     * ກວດຈຳນວນເງິນທີຕ້ອງການທຸລະກຳ
     *
     * !ຈຳນວນເງິນທີຕ້ອງການທຸລະກຳ
     */
    if (!formData?.balanceAmount) {
      _validate.balanceAmount = true;
      _validateMessage.balanceAmount = "ກະລຸນາປ້ອນຈຳນວນເງິນ";
      console.error("formData.balanceAmount empty");
      state = true;
    }

    /**
     * ກວດປະເພດທຸລະກຳ
     *
     * !ປະເພດທຸລະກຳ
     */
    if (!formData?.type) {
      _validate.type = true;
      _validateMessage.type = "ກະລຸນາເລືອກປະເພດທຸລະກຳ";
      console.error("formData.type empty");
      state = true;
    }

    // DONE: validate ດຸນພິນິດ
    /**
     * ກວດດຸນພິນິດ
     */
    if (!formData?.manualCheck) {
      /**
       * ກວດຍອດເງິນຝາກຕ້ອງຕ່ຳສຸດແມ່ນ 20,000 ກີບ
       *
       * ຍອດເງິນທີຕ້ອງການຝາກ < 20,000
       */
      if (
        parseInt(formData?.balanceAmount) < 20000 &&
        formData?.type === "DEPOSIT"
      ) {
        _validate.balanceAmount = true;
        _validateMessage.balanceAmount = "ຈຳນວນການຝາກຕ່ຳສຸດແມ່ນ 20,000 ກີບ";
        console.error("ຈຳນວນການຝາກຕ່ຳສຸດແມ່ນ 20,000 ກີບ");
        state = true;
      }

      /**
       * ກວດຍອດເງິນຝາກຕ້ອງບໍ່ເກີນ 2ລ້ານ/ເດືອນ
       *
       * ຍອດເງິນທີຕ້ອງການຝາກ > 2ລ້ານ
       */
      if (
        parseInt(formData?.balanceAmount) > 2000000 &&
        formData?.type === "DEPOSIT"
      ) {
        _validate.balanceAmount = true;
        _validateMessage.balanceAmount =
          "ຈຳນວນການຝາກສູງສຸດແມ່ນບໍ່ເກີນ 2ລ້ານກີບ/ເດືອນ";
        console.error("ຝາກສູງສຸດແມ່ນບໍ່ເກີນ 2ລ້ານກີບ/ເດືອນ");
        state = true;
      }

      /**
       * ກວດການຖອນເງິນຕ້ອງມີຍອດຄ້າງຕຳສຸດ 20,000 ກີບ
       *
       * (ຍອດເງິນທີຕ້ອງການຖອນ > ຍອດເງິນໃນບັນຊີ) && ເປັນປະເພດຖອນ
       */
      if (
        parseInt(formData?.balanceAmount) >
          parseInt(memberData?.balanceId?.totalBalance) - 20000 &&
        formData?.type === "WITHDRAW"
      ) {
        _validate.balanceAmount = true;
        _validateMessage.balanceAmount = `ສາມາດຖອນໄດ້ແມ່ນບໍ່ເກີນ ${convertNumber(
          parseInt(memberData?.balanceId?.totalBalance) - 20000
        )} ກີບ`;
        console.error(_validateMessage.balanceAmount);
        state = true;
      }
    }

    setValidateMessage((prev) => ({
      ...prev,
      ..._validateMessage,
    }));
    setValidate(_validate);
    return state;
  };
  const handleSearchMember = async () => {
    try {
      if (!inputSearch) return;
      setIsLoading(true);
      setSearchLoading(true);
      setMemberData();
      const member = await get_membe_by_member_no(
        addBranchNo(inputSearch, branchData?.branchNo),
        token
      );

      if (member?.error) {
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ບໍ່ພົບຂໍ້ມູນສະມາຊິກ",
        }));
        throw new Error(member?.message);
      }
      const data = member?.data;
      if (!data) {
        console.log("hear");
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ບໍ່ພົບຂໍ້ມູນສະມາຊິກ",
        }));
        throw new Error("memberData empty");
      }
      setValidateMessage((prev) => ({
        ...prev,
        memberData: "",
      }));
      setValidate((prev) => ({ ...prev, memberData: false }));

      setMemberData(data);
      setFormData((prev) => ({
        ...prev,
        memberId: data?._id,
        fullName: data?.fullName,
        gender: data?.gender,
        balanceId: data?.balanceId,
      }));
      setIsLoading(false);
      setSearchLoading(false);
    } catch (err) {
      setValidate((prev) => ({ ...prev, memberData: true }));
      setMemberData();
      console.error("error", err);
      setIsLoading(false);
      setSearchLoading(false);
    }
  };
  const handleCreateDepositAndWithdraw = async () => {
    try {
      const stateCheck = checkValidate();
      if (stateCheck) throw new Error("validate");

      onSubmit(formData).then(() => {
        setFormData();
        setMemberData();
        setInputSearch();
      });
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };
  const handleClose = () => {
    setMemberData();
    setFormData();
    setValidate();
    setValidateMessage();
    setInputSearch();
    onClose();
  };
  const getMemberDataById = async (memberId) => {
    const _data = await get_member(memberId, token);
    setMemberData(_data?.data);
    const input = cutBranchNo(_data?.data?.memberNo, branchData?.branchNo);
    setInputSearch(input);
  };
  // DONE: ດຶງຂໍມູນ activity history single
  const getActivityHistoryData = async (activityHistoryId) => {
    try {
      const _data = await get_activity_history(activityHistoryId, token);
      console.log("data--->>>", _data);
      setActivityHistory(_data?.data);
      if (_data?.data?.memberId) {
        getMemberDataById(_data?.data?.memberId);
      }
      setFormData((prev) => ({
        ...prev,
        ..._data?.data,
        type: _data?.data?.activityHistoryType
      }));
    } catch (error) {
      console.log("Error getMemberData");
      console.log("Error: ", error);
    }
  };
  const handleUpdateActivityHistoryData = async () => {
    try {
      const stateCheck = checkValidate();
      if (stateCheck) throw new Error("validate");

      onSubmit(formData).then(() => {
        setFormData();
        setMemberData();
        setInputSearch();
      });
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  return (
    <Modal show={open} onHide={handleClose} backdrop="static" size="md">
      <Modal.Header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 700,
        }}
      >
        ແກ້ໄຂທຸລະກຳ
      </Modal.Header>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
        }}
      >
        <div>
          <div style={{ display: "flex" }}>
            {/* TODO: ແປງ ui ຊ່ວງຄົ້ນຫາ */}
            <label>ເລກສະມາຊິກ</label>
            <div style={{ flex: 1 }}></div>
            <label>(ກົດປຸ່ມເພື່ອຄົ້ນຫາ)</label>
          </div>
          <div style={{ marginBottom: 20 }}>
            <InputGroup>
              <Form.Control
                maxLength="4"
                placeholder="ປ້ອນເລກສະມາຊິກ"
                style={{ borderRight: "none" }}
                value={inputSearch}
                onChange={(e) => {
                  convertNumberReverse(e.target.value, (value) => {
                    setInputSearch(value);
                  });
                }}
                isInvalid={validate?.memberData}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearchMember();
                  }
                }}
              />
              <InputGroup.Text
                style={{
                  backgroundColor: "#0178C1",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleSearchMember}
              >
                <Icon
                  icon="tabler:search"
                  style={{ width: 24, height: 24, color: "#FFFFFF" }}
                />
              </InputGroup.Text>
            </InputGroup>
            <div
              style={{
                display:
                  validate?.memberData && validateMessage?.memberData
                    ? "flex"
                    : "none",
                color: "#FF0000",
                gap: 5,
                alignItems: "center",
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>{validateMessage?.memberData}</span>
            </div>
          </div>
        </div>
        <div
          style={{
            display: searchLoading ? "flex" : "none",
            justifyContent: "center",
            height: 150,
            alignItems: "center",
          }}
        >
          <LoadingComponent />
        </div>
        <div
          style={{
            display: !searchLoading ? "flex" : "none",
            flexDirection: "column",
            gap: 20,
            marginBottom: 20,
          }}
        >
          {[
            { title: "ຊື່ ແລະ ນາມສະກຸນ:", value: memberData?.fullName || "-" },
            {
              title: "ເພດ:",
              value: memberData?.gender ? converSex(memberData?.gender) : "-",
            },
            {
              title: "ຈຳນວນເງິນອອມ (ກີບ):",
              value: memberData?.balanceId?.totalBalance
                ? convertNumber(memberData?.balanceId?.totalBalance)
                : "-",
            },
            {
              title: "ຄະແນນ:",
              value: memberData?.balanceId?.totalPoint
                ? convertNumber(memberData?.balanceId?.totalPoint)
                : "-",
            },
          ].map((e, i) => (
            <div className="list-data" key={i}>
              <div>{e?.title}</div>
              <div>{e?.value}</div>
            </div>
          ))}
        </div>
        <div>
          <Form.Label>ປະເພດທຸລະກຳ</Form.Label>
          <div style={{ display: "flex", gap: 20 }}>
            <Form.Check
              type="radio"
              label={`ອອມ`}
              name="type"
              id="radio-type-d"
              isInvalid={validate?.type}
              value="DEPOSIT"
              checked={formData?.type === "DEPOSIT"}
              disabled={true}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  type: e.target.value,
                }))
              }
            />
            <Form.Check
              type="radio"
              label={`ຖອນ`}
              name="type"
              id="radio-type-w"
              isInvalid={validate?.type}
              value="WITHDRAW"
              checked={formData?.type === "WITHDRAW"}
              disabled={true}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  type: e.target.value,
                }))
              }
            />
          </div>
          <div
            style={{
              display:
                validate?.type && validateMessage?.type ? "flex" : "none",
              color: "#FF0000",
              gap: 5,
              alignItems: "center",
            }}
          >
            <Icon
              icon="material-symbols:info-outline"
              style={{ width: 18, height: 18 }}
            />
            <span>{validateMessage?.type}</span>
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນເງິນ (ກີບ)</Form.Label>
          <FormControlCustom
            type="text"
            placeholder="ປ້ອນຈຳນວນເງິນ"
            value={convertNumber(formData?.balanceAmount)}
            isInvalid={validate?.balanceAmount}
            isInvalidMessage={validateMessage?.balanceAmount}
            defaultValue=""
            onChange={(e) => {
              convertNumberReverse(e?.target?.value, (value) => {
                setFormData((prev) => ({
                  ...prev,
                  balanceAmount: value,
                }));
              });
            }}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          {/* DONE:  ດຸນພິນິດຕ້ອນ ອັບເດດລາຍການ deposit */}
          <Form.Check // prettier-ignore
            type="checkbox"
            id={`default-checkbox`}
            label={`ຕ້ອງການອອມເກີນຂັ້ນຕ່ຳ ຫຼື ເກີນຂັ້ນສູງສຸດ`}
            checked={formData?.manualCheck}
            onChange={(e) => {
              if (e.target.checked) {
                setBackupFormData({
                  formData: formData,
                  memberData: memberData,
                  inputSearch: inputSearch,
                });
                setPopup({ PopUpConfirmDiscretion_for_update: true });
              } else {
                setFormData((prev) => ({
                  ...prev,
                  manualCheck: e.target.checked,
                }));
              }
            }}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>
            ລາຍລະອຽດ <span style={{ color: "#CED4DA" }}>(ບໍ່ກຳນົດ)</span>
          </Form.Label>
          <FormControlCustom
            as="textarea"
            placeholder="ປ້ອນລາຍລະອຽດ"
            style={{ height: "100px" }}
            value={formData?.description}
            isInvalid={validate?.description}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                description: e?.target?.value,
              }))
            }
          />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 30 }}>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={handleClose}
          >
            ຍົກເລີກ
          </Button>
          <Button style={{ flex: 1 }} onClick={handleUpdateActivityHistoryData}>
            ບັນທຶກ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
